module.exports = __webpack_public_path__ + "img/logo.0a863c26.png";